/**
 *
 * Asynchronously loads the component for AutoLogin
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AutoLogin = lazyLoad(
  () => import('./index'),
  module => module.AutoLogin,
);
